import axios from "axios"
import { CalculateInsuranceFee } from "../../shared/utils"

export const AddressForm = () => ({
  country: null,
  level_1: null,
  level_2: null,
  street: null,
  postal_code: null,
  optionsLevel1: [],
  optionsLevel2: [],
  previewFront: null,
  previewBack: null,
  defaultCountry: null,
  defaultCity: null,
  defaultDistrict: null,
  maxFileSize: 2 * 1024 * 1024,
  allowedFormats: ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp'],

  init() {
    // 會收到shipping selector的通知
    window.AddressFormInstance = this;

    if (this.$el.dataset.initCountry) {
      this.country = this.$el.dataset.initCountry
    }

    if (this.$el.dataset.initLevel1) {
      this.level_1 = this.$el.dataset.initLevel1
    }

    if (this.$el.dataset.initLevel2) {
      this.level_2 = this.$el.dataset.initLevel2
    }

    const hasSelectedAddress = document.querySelector('input[name="selected_address"]:checked');
    if (hasSelectedAddress) {
      this.getAddress(hasSelectedAddress)
    }
    if (this.country && this.level_1 ) {
      this.loadLevel1Options()
    }
    document.addEventListener('shipping-method-changed', () => {
      this.clearAddress();
    });
  },

  clearAddress() {
    const checkedRadio = document.querySelector('input[name="selected_address"]:checked');
    if (checkedRadio) {
      checkedRadio.checked = false;
    }

    this.level_1 = null;
    this.level_2 = null;
    this.street = "";
    this.postal_code = ""
  },
  getAddress(addressElement) {
    // 找到整包預設地址資料
    const label = addressElement.closest('label');
    // 從 label 內部提取資料
    const country = label.querySelector('[data-default-country]').dataset.defaultCountry;
    const level_1 = label.querySelector('[data-default-level1]').dataset.defaultLevel1;
    const level_2 = label.querySelector('[data-default-level2]').dataset.defaultLevel2;
    const street = label.querySelector('[data-default-street]').dataset.defaultStreet;
    const postal = label.querySelector('[data-default-postal]').dataset.defaultPostal;

    this.$store.frontend.countryCode = country;
    this.level_1 = level_1;
    this.level_2 = level_2;
    this.street = street;
    this.postal_code = postal;
    this.loadLevel1Options()
  },

  async loadLevel1Options() {
    const url = new URL("/api/v1/address/level1_options", window.location.origin)    
    if(this.$store.frontend.countryCode){
      this.country = this.$store.frontend.countryCode;
    }
    url.searchParams.append("country", this.country)

    try {
      const { data } = await axios.get(url.toString())
      this.optionsLevel1 = data

      this.loadLevel2Options()
    } catch (error) {
      console.error("無法獲取 level 1 選項:", error)
    }
  },

  async loadLevel2Options() {
    if (!this.level_1) return

    const url = new URL("/api/v1/address/level2_options", window.location.origin)
    url.searchParams.append("country", this.country)
    url.searchParams.append("level_1", this.level_1)
    url.searchParams.append("locale", "tw")

    try {
      const { data } = await axios.get(url.toString())
      this.optionsLevel2 = data
    } catch (error) {
      console.error("無法獲取 level 2 選項:", error)
    }
  },

  insuranceFee(price, country, currency = "TWD") {
    return CalculateInsuranceFee(price, country, currency)
  },

  validateFile(file) {
    if (!file) {
      return { isValid: false, message: '請選擇檔案' }
    }

    if (file.size > this.maxFileSize) {
      const sizeMB = (file.size / 1024 / 1024).toFixed(2)
      return {
        isValid: false,
        message: `檔案大小不能超過 2 MB，目前為 ${sizeMB}MB`
      }
    }

    if (!this.allowedFormats.includes(file.type)) {
      return {
        isValid: false,
        message: '檔案格式不正確，請上傳 PNG、JPG、JPEG 或 BMP 格式的圖片'
      }
    }

    return { isValid: true, message: '' }
  },

  handleIdCardFrontChange(event) {
    const file = event.target.files[0]
    const validation = this.validateFile(file)

    if (!validation.isValid) {
      alert(`證件正面上傳失敗：${validation.message}`)
      event.target.value = ''
      this.previewFront = null
      return
    }

    this.previewFront = URL.createObjectURL(file)
  },

  handleIdCardBackChange(event) {
    const file = event.target.files[0]
    const validation = this.validateFile(file)

    if (!validation.isValid) {
      alert(`證件反面上傳失敗：${validation.message}`)
      event.target.value = ''
      this.previewBack = null
      return
    }

    this.previewBack = URL.createObjectURL(file)
  }
})